module.exports = __webpack_public_path__ + "img/clock6-01.61116ae8.png";